import { render, staticRenderFns } from "./correspondence-form.vue?vue&type=template&id=0fb2be5c"
import script from "./correspondence-form.vue?vue&type=script&lang=js"
export * from "./correspondence-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports